import { flushSync } from 'react-dom';

/**
 * One scene into the next without a jump cut: the View Transitions API
 * cross-fades the old frame into the new one (the default is a quick
 * dissolve; CSS in styles.css shapes it). Where the browser has no support,
 * or motion is reduced, the change simply happens.
 */
export function transition(change: () => void): void {
  const doc = document as Document & { startViewTransition?: (cb: () => void) => unknown };
  const still = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  if (!doc.startViewTransition || still) { change(); return; }
  doc.startViewTransition(() => flushSync(change));
}
